import { formatCreateVenuePayload } from '../';
import { createVenue, ICreateVenueBody } from 'src/api/createVenue';
import { mapVenueToDetailsPage } from 'src/pages/Venue/mapVenueToDetailsPage/mapVenueToDetailsPage';
import { toApiError } from 'src/helpers/apiError';
import { IVenueCreateFormValues } from '../../types';
import { CREATE_VENUE_FAILED_MESSAGE } from '../../constants';

const createVenueForm = async (data: IVenueCreateFormValues) => {
  const payload: ICreateVenueBody = formatCreateVenuePayload(data);
  const response = await createVenue(payload);
  if (!response.ok) {
    throw await toApiError(response, CREATE_VENUE_FAILED_MESSAGE);
  }

  const newVenue = await response.json();
  const formattedVenue = mapVenueToDetailsPage(newVenue.data[0]);

  return formattedVenue;
};

export default createVenueForm;
